"use client";
import {
  __async
} from "../../../chunk-MMUBH76A.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { CpslButton, CpslSpinner, CpslText } from "@getpara/react-components";
import { useEffect, useState } from "react";
import { styled } from "styled-components";
import { ModalStep } from "../../utils/steps.js";
import { useModalStore, useThemeStore, useUserInfoStore } from "../../stores/index.js";
import { ErrorContainer, ErrorIcon, Heading, InnerStepContainer, StepContainer } from "../common.js";
import { AuthMethod } from "@getpara/core-sdk";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
import { useExternalWallets } from "../../providers/ExternalWalletContext.js";
const ExternalWalletVerificationStep = () => {
  const theme = useThemeStore((state) => state.theme);
  const authInfo = useUserInfoStore((state) => state.getAuthInfo());
  const setStep = useModalStore((state) => state.setStep);
  const setWebAuthURLForCreate = useModalStore((state) => state.setWebAuthURLForCreate);
  const isIFrameReady = useModalStore((state) => state.isIFrameReady);
  const setIsIFrameReady = useModalStore((state) => state.setIsIFrameReady);
  const setIFrameUrl = useModalStore((state) => state.setIFrameUrl);
  const externalWalletError = useModalStore((state) => state.externalWalletError);
  const setExternalWalletError = useModalStore((state) => state.setExternalWalletError);
  const para = useInternalClient();
  const { verifyWalletSignature } = useExternalWallets();
  const [shouldRouteToStep, setShouldRouteToStep] = useState();
  const [isVerifying, setIsVerifying] = useState(false);
  useEffect(() => {
    handleVerifyWallet();
  }, []);
  useEffect(() => {
    if (!!shouldRouteToStep && isIFrameReady) {
      setTimeout(() => {
        setStep(shouldRouteToStep);
        setIsVerifying(false);
      }, 200);
    }
  }, [shouldRouteToStep, isIFrameReady]);
  const handleVerifyWallet = () => __async(void 0, null, function* () {
    setIsVerifying(true);
    try {
      setIsIFrameReady(false);
      const supportedCreateAuthMethods = yield para.getSupportedCreateAuthMethods();
      const walletSignature = yield verifyWalletSignature();
      if (!walletSignature.signature || !walletSignature.address) {
        console.error("No signature or address found on the verifyWalletSignature response.");
        setIsVerifying(false);
        return;
      }
      const url = yield para.verifyExternalWallet({
        address: walletSignature.address,
        signedMessage: walletSignature.signature,
        cosmosPublicKeyHex: walletSignature.cosmosPublicKeyHex,
        cosmosSigner: walletSignature.cosmosSigner
      });
      if (supportedCreateAuthMethods.has(AuthMethod.PASSWORD) && supportedCreateAuthMethods.has(AuthMethod.PASSKEY)) {
        const passwordAuthUrl = yield para.getSetupPasswordURL({ authType: authInfo == null ? void 0 : authInfo.authType, theme });
        setWebAuthURLForCreate(yield para.shortenLoginLink(url));
        setIFrameUrl(yield para.shortenLoginLink(passwordAuthUrl));
        setShouldRouteToStep(ModalStep.BIOMETRIC_CREATION);
        return;
      } else if (supportedCreateAuthMethods.has(AuthMethod.PASSWORD)) {
        const url2 = yield para.getSetupPasswordURL({ authType: authInfo == null ? void 0 : authInfo.authType, theme });
        setIFrameUrl(yield para.shortenLoginLink(url2));
        setShouldRouteToStep(ModalStep.PASSWORD_CREATION);
        return;
      } else {
        setWebAuthURLForCreate(yield para.shortenLoginLink(url));
        setStep(ModalStep.BIOMETRIC_CREATION);
      }
    } catch (e) {
      console.error("Error verifying signature:", e);
      setExternalWalletError(["Signature verification failed."]);
      setIsVerifying(false);
    }
  });
  return /* @__PURE__ */ jsxs(StepContainer, { $wide: true, children: [
    /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      /* @__PURE__ */ jsx(Heading, { variant: "headingS", weight: "bold", children: "Verify Your Wallet" }),
      /* @__PURE__ */ jsx(InlineText, { variant: "bodyS", color: "secondary", children: "Sign the message with your wallet to complete sign up." }),
      !!(externalWalletError == null ? void 0 : externalWalletError[0]) && /* @__PURE__ */ jsxs(ErrorContainer, { children: [
        /* @__PURE__ */ jsx(ErrorIcon, { icon: "alertCircle" }),
        /* @__PURE__ */ jsx(CpslText, { weight: "semiBold", color: "error", children: externalWalletError == null ? void 0 : externalWalletError[0] })
      ] })
    ] }),
    /* @__PURE__ */ jsx(InnerStepContainer, { children: isVerifying ? /* @__PURE__ */ jsx(CpslSpinner, {}) : /* @__PURE__ */ jsx(CpslButton, { onClick: handleVerifyWallet, children: "Retry" }) })
  ] });
};
const InlineText = styled(CpslText)`
  text-align: center;
  display: inline-block;
`;
export {
  ExternalWalletVerificationStep
};
